export default [
  {
    name: 'questionFaceVerify',
    path: '/question/face-verify',
    component: () =>
      import(
        /* webpackChunkName: "questionFaceVerify" */ '@/views/question/face-verify'
      ),
    meta: { title: '常见问题' },
  },
];
